<div class="flex flex-col gap-2">
  @if (isLoadingData()) {
    <mat-progress-bar mode="indeterminate" class="mb-4"></mat-progress-bar>
  }
  
  <div class="flex flex-row gap-2">
    <div class="flex flex-col h-full w-1/2 flex-shrink-0">
      <h2>{{editorData().arabic.title ?? ""}} (arabic)</h2>
      <quill-editor class="arabic-editor" (onEditorCreated)="activateRTL($event)" dir="ltr"
        placeholder="...أدخل النص هنا" [formControl]="editorData().arabic.controller" theme="snow">
      </quill-editor>
    </div>
    <div class="flex flex-col h-full w-1/2 flex-shrink-0">
      <h2>{{editorData().english.title ?? ""}} (english)</h2>
      <quill-editor dir="ltr" [formControl]="editorData().english.controller" theme="snow">
      </quill-editor>
    </div>
  </div>
  <cac-button class="w-max" [disabled]="isLoadingData()" *ngIf="updateFunction() !== null" (onClick)="update($event)">Update
    {{editorData().english.title}}</cac-button>
</div>